export enum Dataset {
  BUTTON_TEXT = 'buttonText',
  ENABLE_PARTNER_PRIVACY = 'enablePartnerPrivacy',
  PARTNER_PRIVACY_LINK = 'partnerPrivacyLink',
  FOOTNOTE_TEXT = 'footnoteText',
  SOURCE = 'source',
  SUBTITLE_TEXT = 'subtitleText',
  TITLE_TEXT = 'titleText',
  OPEN_LINK_URL = 'openLinkUrl',
  ENABLE_MAU = 'enableMau',
  MIXPANEL_ATTRIBUTE = 'mixpanelAttribute',
  METRIC_EVENT = 'metricEvent',
  HIDE_PHONE = 'hidePhone',
}

export type THidePhone = string | boolean | undefined;

export type PrivacyLinkObject = {
  id: number,
  url: string,
  label: string
};

export type RootProps = {
  readonly [Dataset.SOURCE]: string;
  readonly [Dataset.TITLE_TEXT]: string;
  readonly [Dataset.SUBTITLE_TEXT]: string;
  readonly [Dataset.ENABLE_PARTNER_PRIVACY]: boolean;
  readonly [Dataset.FOOTNOTE_TEXT]: string;
  readonly [Dataset.BUTTON_TEXT]: string;
  readonly [Dataset.OPEN_LINK_URL]: string | undefined;
  readonly [Dataset.ENABLE_MAU]: boolean;
  readonly [Dataset.MIXPANEL_ATTRIBUTE]: string;
  readonly [Dataset.METRIC_EVENT]: string;
  readonly [Dataset.HIDE_PHONE]: boolean;
  readonly partnerPrivacyLinkList: Array<PrivacyLinkObject>
};

export type RootState = {
  readonly isLoadedCountry: boolean;
  readonly findCountryCode: string;
  readonly isSubmitted: boolean;
  readonly isCaughtError: boolean;
};

export enum FormErrors {
  BUSINESS_EMAIL = 'Please enter a business email address.',
}
